define('commons/filter-form',['jquery', 'commons/message-manager', 'commons/loading-mask', 'commons/popup-dialog', 'commons/list-columns-customizer',
        'commons/html-table-factory', 'commons/quick-actions', 'commons/xor-form', 'jquery-ui-timepicker-addon', 'chosen'], 
        function($, messages, LoadingMask, PopupDialog, ListColumnsCustomizer, htmlTableFactory, QuickActions, XorForm) {

    var FilterForm = function(container, options) {
        var here = this;
        this.form = $(container).get(0);
        this.autoRefreshTimer = null;
        this.listCustomizer = null;
        this.quickActions = null;
        this.containerSelector = container;

        // Setting the configuration
        this.settings = $.extend({
            paginationLinks: '.paginator-link',
            sortLinks: '.sort-link',
            actionLinks: '.action-link',
            insertResultIn: '.filter-result',
            newItem: '.new-item',
            popupLinks: '.popupLink',
            popupReload: -1,
            dataType: 'html',
            popupTitle: '',
            popupSettings: null,
            pageParams: null,
            maxDate: null,
            minDate: null,
            resultPerPage: 100,
            refreshPeriod: 5000,
            autoRefresh: false,
            onDataLoaded : [],
            loadDataOnStart: true,
            submitOnReset : true,
            onSubmit: function() {
                return true;
            },
            onReset: function() {
                return true;
            },
            beanName: '',
            customizableList: false,
            quickActions : false,
            quickActionsUrl : '${id}/actions',
            onActionsMenuOpen : null,
            emptyMessage : 'There are no elements to display',
            headerContainer: 'table.data thead',
            bodyContainer: 'table.data tbody'
        }, options);

        // Create popup
        var popupOptions = {
            popupTitle: this.settings.popupTitle,
            popupLinks: this.settings.popupLinks,
            reload: this.settings.popupReload,
            resizable: true
        };
        
        if(this.settings.customizableList){
            this.settings.onDataLoaded.splice(0, 0, htmlTableFactory);
        }
        if (this.settings.popupSettings !== null) {
            popupOptions = $.extend(popupOptions, this.settings.popupSettings);
        }
        this.popup = new PopupDialog(this.form, popupOptions);
        this.form.resetPage = false;
        this.form.pageParams = this.settings.pageParams;

        var $form = $(this.form);
        // Add a callback function to the submit form method
        $form.submit(function() {
            if (here.settings.onSubmit()) {
                here.requestForm(false, here.settings.autoRefresh);
            }
            return false;
        });

        $form.keydown(function() {
            here.stopAutoRefresh();
        });

        $form.find('select').each(function() {
            $this = $(this);
            $this.focus(function() {
                here.stopAutoRefresh();
            });
        });

        $form.find(':reset').each(function() {
            $(this).mousedown(function() {
                if (here.reset()) {
                    $form.submit();
                }
            });
        });

        // Date picker
        $(container).find('.date-picker').each($.proxy(function(index, value) {
            var $value = $(value);
            var me = this;
            var datePickerOptions = {
                altField: '#' + value.id + '-alt',
                altFormat: $.datepicker.ISO_8601
            };
            if (this.settings.maxDate !== null) {
                datePickerOptions.maxDate = this.settings.maxDate;
            }
            if (this.settings.minDate !== null) {
                datePickerOptions.minDate = this.settings.minDate;
            }
            $value.datepicker(datePickerOptions);

            $value.blur($.proxy(function(e) {
                $value = $(e.target);
                if ($value.val().length === 0) {
                    $('#' + $value.attr('id') + '-alt').val('');
                }
                var date = new Date($value.val());
                if (this.settings.maxDate != null && this.settings.maxDate.getTime() < date.getTime()) {
                    var dateFormat = $($value).datepicker( 'option', 'dateFormat' );
                    $value.datepicker('setDate', $.formatDateTime(dateFormat, this.settings.maxDate), {utc : true});
                } else if (this.settings.minDate != null && this.settings.minDate.getTime() > date.getTime()) {
                    var dateFormat = $($value).datepicker( 'option', 'dateFormat' );
                    $value.datepicker('setDate', $.formatDateTime(dateFormat, this.settings.minDate), {utc : true});
                }
            }, me));
            
        }, this));

        $(container).find('.date-time-picker').each($.proxy(function(index, node) {
            var $node = $(node);
            var $nodeAlt = $('#' + node.id + '-alt');
            $node.datetimepicker({
                altField: '#' + node.id + '-alt',
                altFormat: $.datepicker.ISO_8601,
                altTimeFormat: 'HH:mm:ss',
                altFieldTimeOnly: false,
                showSecond: false
            });
            $node.blur(function() {
                if (node.value.length === 0) {
                    $nodeAlt.val('');
                }
            });
        }, this));

        //handle xor fields
        this.xorForm = new XorForm(container, {radioName : 'xor-radio-button'});

        this.loadingMask = new LoadingMask(container + " " + this.settings.insertResultIn, {
            iconPosition: '50% 100px'
        });
        if (this.settings.loadDataOnStart) {
            this.requestForm(false, this.settings.autoRefresh);
        }
        
        // Turn all filters <select> into chosen selects
        $form.find('select:not(.ignore-chosen,.accordion-ignore-chosen)').removeClass('hidden').chosen({
            disable_search_threshold: 7,
            allow_single_deselect: true,
            search_contains : true,
            no_results_text: 'Nothing found for '
        });
        
        $("button[type='reset']").prop('disabled', false);
        $("button[type='submit']").prop('disabled', false);

        this.cnt = 0;
    };
    

    FilterForm.prototype.submit = function(){
        $(this.form).submit();
    };

    FilterForm.prototype.reset = function() {
        if (this.settings.onReset()) {
            // Reset the form
            this.form.reset();
            // Resets hidden fields since Firefox skips them
            var $form = $(this.form);
            $form.find('option:selected').removeAttr('selected');
            $form.find('input:hidden').each(function() {
                if (!$(this).data('noReset')) {
                    this.value = '';
                }
            });
            $form.find('select').trigger('chosen:updated');
            
            //remove nodes from multiple levels (ex. locations)
            $form.find("[name^='level_']").each(function( index ) {
                $(this).next().remove();
                $(this).remove();
            });
            
            this.cnt = 0;
            this.innerReset();
            return this.settings.submitOnReset;
        }
        return false;
    };
    
    /**
     * To be overridden by subclasses if necessary
     */
    FilterForm.prototype.innerReset = function(){};
    
    FilterForm.prototype.requestForm = function(update, autoRefresh) {
        var here = this;
        var $form = $(here.form);
        here.stopAutoRefresh();
        if (here.form.resetPage && here.form.pageParams) {
            var idx = here.form.pageParams.indexOf(':');
            if (idx > -1) {
                // keep sorting filter and reset only pagination
                here.form.pageParams = 'pg=1' + here.form.pageParams.substring(idx);
            } else {
                here.form.pageParams = false;
            }
        }
        if (!update) {
            this.loadingMask.show();
        }
        $.ajax({
            type: here.form.method || 'GET',
            url: here.form.action,
            dataType: here.settings.dataType,
            data: $form.serialize() + (here.form.pageParams ? '&' + here.form.pageParams : '') + '&update=' + update,
            error: function(xhr, textStatus, errorThrown) {
                if (xhr.status > 0) {
                    var resultNode = $form.find(here.settings.insertResultIn);
                    resultNode.html('An error occured');
                }
            },
            success: function(data) {
                here.loadingMask.hide();
                here.form.resetPage = true;

                if (here.settings.onUnbind) {
                    here.settings.onUnbind.call(here);
                }

                // Clean the sort link event binding
                $form.find(here.settings.sortLinks).each(function(index, link) {
                    $(link).unbind();
                });

                // Clean the pagination link event binding
                $form.find(here.settings.paginationLinks).each(function(index, link) {
                    $(link).unbind();
                });

                // Clean the popup links event binding
                here.popup.unbind();

                // Clean the action links
                $form.find(here.settings.actionLinks).each(function(index, link) {
                    $(link).unbind();
                });

                here.loadingMask.detach();
                here.handleResult(data);
                here.loadingMask.attach();
                
                // Custom list (optional) ------------------------------------------------------------
                if (here.settings.customizableList) {
                    if(here.listCustomizer == null){
                        here.listCustomizer = new ListColumnsCustomizer('table.data', here.settings.beanName, function(selectedFields) {
                            $.ajax({
                                type: 'POST',
                                url: '/userPrefs/edit',
                                contentType: 'application/json; charset=UTF-8',
                                data: JSON.stringify({'beanClass' : here.settings.beanName, 'fields' : selectedFields }),
                                success: function(data) {
                                    here.requestForm(update, autoRefresh);
                                }
                            });
                        });
                    } else{
                        here.listCustomizer.customizeContainer('table.data');
                    }
                }
                
                // Quick action part (optional) ------------------------------------------------------
                if(here.settings.quickActions){
                    if(here.quickActions == null){
                        here.quickActions = new QuickActions('table.data tbody tr', {
                            onActionsMenuOpen : here.settings.onActionsMenuOpen,
                            quickActionsUrl : here.settings.quickActionsUrl
                        });
                    }else{
                        here.quickActions.enhance('table.data tbody tr');
                    }
                }
                
                // Catches the pagination events
                $form.find(here.settings.paginationLinks).each(function(index, link) {
                    $(link).click(function(event) {
                        here.form.pageParams = $(this).data('params');
                        here.form.resetPage = false;
                        $form.submit();
                        return false;
                    });
                });

                // Catches the sort events
                $form.find(here.settings.sortLinks).each(function(index, link) {
                    $(link).click(function(event) {
                        here.form.pageParams = $(this).data('params');
                        here.form.resetPage = true;
                        $form.submit();
                        return false;
                    });
                });

                // Catches the action events
                $form.find(here.settings.actionLinks).each(function(index, link) {
                    $(link).click(function(event) {
                        $.ajax({
                            type: 'GET',
                            url: $(this).attr('href'),
                            dataType: 'json',
                            error: function() {
                                messages.error('Unexpected error occurs');
                            },
                            success: function(data) {
                                if (data.message) {
                                    messages.info(data.message);
                                }
                            }
                        });
                        return false;
                    });
                });

                // Catches the show popup click events
                here.popup.bind();

                if (here.settings.onBind) {
                    here.settings.onBind.call(here);
                }

                if (autoRefresh) {
                    here.startAutoRefresh();
                }
            }
        });
    };

    FilterForm.prototype.getPage = function() {
        if (this.form.page !== undefined && this.form.page.value !== "") {
            return this.form.page.value;
        } else {
            return 1;
        }
    };

    // To be overridden
    FilterForm.prototype.onLinkClick = function(link) {
    };

    FilterForm.prototype.startAutoRefresh = function() {
        if(!this.settings.autoRefresh){
            return;
        }
        this.stopAutoRefresh();
        if (this.getPage() == 1) {
            this.autoRefreshTimer = window.setTimeout($.proxy(function() {
                this.requestForm(true, true);
            }, this), this.settings.refreshPeriod);
        }
    };   

    FilterForm.prototype.stopAutoRefresh = function() {
        if(!this.settings.autoRefresh){
            return;
        }
        window.clearTimeout(this.autoRefreshTimer);
    };

    FilterForm.prototype.increment = function() {
        this.cnt++;
        this.stopAutoRefresh();
    };

    FilterForm.prototype.decrement = function() {
        this.cnt--;
        if (this.cnt == 0) {
            this.startAutoRefresh();
        }
    };

    FilterForm.prototype.enhanceJsonModel = function( data ) {
        data.emptyMessage = this.settings.emptyMessage;
        data.headerContainer = this.settings.headerContainer;
        data.bodyContainer = this.settings.bodyContainer;
    };
    
    FilterForm.prototype.handleResult = function(data) {
        var contextData;
        
        if(this.settings.dataType == 'html'){
            // Insert result
            var resultNode = $(this.form).find(this.settings.insertResultIn);
            resultNode.html(data);
            // Highlights new items
            resultNode.find(this.settings.newItem).each(function() {
                $(this).effect('highlight', {}, 2000);
            });
        }else if(this.settings.dataType == 'json'){
           this.enhanceJsonModel(data);
            contextData = data;
        }else{
            throw "Expecting 'json' or 'html' as resultType";
        }
        
        if ($.isArray(this.settings.onDataLoaded) && this.settings.onDataLoaded.length > 0) {
            var argLength = this.settings.onDataLoaded.length;
            for (var i = 0; i < argLength; i++) {
                var functionToApply = this.settings.onDataLoaded[i];
                if ($.isFunction(functionToApply)) {
                    functionToApply.apply(this, [contextData, this.containerSelector]);
                }
            }
        }

        $('table.data a[title]').mouseover($.proxy(function() {
            this.increment();
        }, this)).mouseout($.proxy(function() {
            this.decrement();
            $('.ui-tooltip-content').parents('div').remove();
        }, this)).click($.proxy(function() {
            $('.ui-tooltip-content').parents('div').remove();
        }, this));
    };

    return FilterForm;
});

